import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import createSagaMiddleware from 'redux-saga';
import { connectRouter, routerMiddleware } from 'connected-react-router';

import rootSaga from './sagas/rootSaga';
import { history } from 'utils';
import menuReducer from './slices/menuSlice';
import shopReducer from './slices/shopSlice';
import { billReducer } from './slices/billSlice';
import { authReducer } from './slices/authSlice';
import settingsReducer from './slices/settingsSlice';

const rootReducer = combineReducers({
  // router: connectRouter(history),
  counter: counterReducer,
  menu: menuReducer,
  shop: shopReducer,
  bill: billReducer,
  auth: authReducer,
  settings: settingsReducer,
});

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,

  // Add saga to toolkit
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
  // getDefaultMiddleware().concat(sagaMiddleware, routerMiddleware(history))
});

// Add root  saga
sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
